<template>
  <div class="subActivityManage">
    <div class="subActivityManageBox">
      <el-row>
        <el-col :span="22">历史记录</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <br/>

      <!--      <el-row>-->
      <!--        <el-col :span="20">数据筛选</el-col>-->
      <!--        <el-col :span="4">-->
      <!--          <el-button type="success" round icon="el-icon-search" size="small" @click="searchData">查 询</el-button>-->
      <!--          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--      <el-row :gutter="5" class="filter">-->
      <!--        <el-col :span="6">-->
      <!--          <span class="label">活动</span>-->
      <!--          <el-input-->
      <!--            v-model="tableConfig.name"-->
      <!--            placeholder="活动名称"-->
      <!--            style="width: auto"-->
      <!--          ></el-input>-->
      <!--        </el-col>-->
      <!--        <el-col :span="6">-->
      <!--          <span class="label">开始时间</span>-->
      <!--          <el-date-picker-->
      <!--            v-model="tableConfig.startTime"-->
      <!--            type="date"-->
      <!--            value-format="yyyy-MM-dd"-->
      <!--            placeholder="选择日期">-->
      <!--          </el-date-picker>-->
      <!--        </el-col>-->
      <!--        <el-col :span="6">-->
      <!--          <span class="label">截止时间</span>-->
      <!--          <el-date-picker-->
      <!--            v-model="tableConfig.endTime"-->
      <!--            type="date"-->
      <!--            value-format="yyyy-MM-dd"-->
      <!--            placeholder="选择日期">-->
      <!--          </el-date-picker>-->
      <!--        </el-col>-->
      <!--        <el-col :span="6">-->
      <!--          <span class="label">状态</span>-->
      <!--          <el-select v-model="tableConfig.status" placeholder="">-->
      <!--            <el-option-->
      <!--              v-for="(item, index) in statusList"-->
      <!--              :key="index"-->
      <!--              :label="item.name"-->
      <!--              :value="item.statusNo"-->
      <!--            >-->
      <!--            </el-option>-->
      <!--          </el-select>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <el-divider></el-divider>

      <el-row>
        <el-col :span="20">数据列表</el-col>
        <el-col :span="4">
          <!--          <el-button-->
          <!--            plain-->
          <!--            round-->
          <!--            icon="el-icon-plus"-->
          <!--            size="small"-->
          <!--            style="color: #67C23A"-->
          <!--            @click="openCreate()"-->
          <!--          >-->
          <!--            新 建-->
          <!--          </el-button>-->
          <!--          <el-button-->
          <!--            plain-->
          <!--            round-->
          <!--            icon="el-icon-minus"-->
          <!--            size="small"-->
          <!--            style="color: #67C23A"-->
          <!--            @click="deleteActivities()"-->
          <!--          >-->
          <!--            删 除-->
          <!--          </el-button>-->
        </el-col>
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          sortable
          prop="name"
          label="活动名称"
        ></el-table-column>
        <el-table-column
          sortable
          prop="startTime"
          label="开始时间"
          width="200"
        ></el-table-column>
        <el-table-column
          sortable
          prop="endTime"
          label="截止时间"
          width="200"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="uncheckedNumber"
          label="待检查门店"
          width="120"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="status"
          label="活动状态"
          width="110"
          :formatter="statusFormatter"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="enabled"
          label="启用状态"
          width="110"
          :formatter="enabledFormatter"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.type==='temp'" type="text" style="color: #606266" icon="el-icon-check" size="mini"
                       @click="openCheck(scope.row.id)">检查
            </el-button>
            <el-button v-if="scope.row.enabled===false && scope.row.status === 1" type="text" style="color: #606266"
                       icon="el-icon-edit" size="mini" @click="openEdit(scope.row.id)">编辑
            </el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini"
                       @click="openDetail(scope.row.id)">查看
            </el-button>
            <el-button v-if="scope.row.status !== 2 && scope.row.enabled===false" type="text" style="color: #606266"
                       icon="el-icon-delete" size="mini" @click="deleteActivity(scope.row.id)">删除
            </el-button>
            <el-button v-if="scope.row.status === 2 || scope.row.status === 3" type="text" style="color: #606266"
                       icon="el-icon-download" size="mini" @click="exportReply(scope.row.id)">导出回复
            </el-button>
            <el-button v-if="scope.row.status === 2 || scope.row.status === 3" type="text" style="color: #606266"
                       icon="el-icon-download" size="mini" @click="exportImage(scope.row.id)">导出图片
            </el-button>
            <el-button v-if="scope.row.status === 2 || scope.row.status === 3" type="text" style="color: #606266"
                       icon="el-icon-download" size="mini" @click="exportRecord(scope.row.id)">下载列表
            </el-button>
            <el-button v-if="scope.row.status !== 2 && scope.row.enabled===false" type="text" style="color: #606266"
                       icon="el-icon-circle-plus-outline" size="mini"
                       @click="enableActivity(scope.row.id, '启用', true)">启用
            </el-button>
            <el-button v-if="scope.row.status !== 3 && scope.row.status !== 2 && scope.row.enabled===true" type="text"
                       style="color: #606266" icon="el-icon-remove-outline" size="mini"
                       @click="enableActivity(scope.row.id, '禁用', false)">禁用
            </el-button>
            <el-button v-if="scope.row.status === 2 && scope.row.enabled===true" type="text" style="color: #606266"
                       icon="el-icon-remove-outline" size="mini"
                       @click="forcedDisable(scope.row.id, '强制禁用', false)">强制禁用
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>

    <el-dialog
      title="预约下载列表"
      :visible.sync="downloadDialog"
      width="60%"
      center>
      <div class="downloadList">
        <el-table :data="downloadList">
          <el-table-column property="name" label="预约人"></el-table-column>
          <el-table-column property="exportTime" label="预约时间"></el-table-column>
          <el-table-column property="status" label="状态" :formatter="statusImageFormatter"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 'ok'"
                type="text"
                size="mini"
                @click="downloadData(scope.row.urls)"
              >下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <footer>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="downloadCurrentChange"
            :current-page="downloadTableConfig.current"
            :total="downloadTotal"
          ></el-pagination>
        </footer> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>


</template>
<script>
import _ from "lodash";

export default {
  name: "subActivityManage",
  data() {
    return {
      id: this.$route.query.id || null,
      initialFilterData: {
        name: "",
        startTime: "", //开始时间
        endTime: "", //截止时间
        status: "", //活动状态"
        uncheckedNumber: "",
        // enabled: "", //启用状态
        parentId: this.id
      },
      downloadDialog: false,
      downloadList: [], //下载列表
      multipleSelection: [],
      statusList: [
        {
          name: '未开始',
          statusNo: 1
        },
        {
          name: '进行中',
          statusNo: 2
        },
        {
          name: '已结束',
          statusNo: 3
        },
      ],
      tableData: [], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
        name: "",
        startTime: "", //开始时间
        endTime: "", //截止时间
        status: "", //活动状态"
        uncheckedNumber: "",
        // enabled: "", //启用状态
        parentId: this.id
      },
      tableLoading: false
    }
  },
  mounted() {
    this.clearFilter();
    this.getData();
  },
  methods: {
    searchData() {
      this.tableConfig.current = 1;
      this.tableConfig.parentId = this.id;
      this.getData();
    },
    async getData() {
      this.tableConfig.parentId = this.id * 1;
      // 获取列表
      this.tableLoading = true;
      let res = await axios.post(vmsReqUrl+"/activity/subActivityList", this.tableConfig);
      res = res.data;
      if (res.code === 200) {
        this.tableData = res.data.records || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openCreate() {
      this.$router.push({path: '/vms/activityEdit'});
    },
    openEdit(id) {
      this.$router.push({path: '/vms/activityEdit', query: {id}});
    },
    openDetail(id) {
      this.$router.push({path: '/vms/activityDetail', query: {id}});
    },
    openCheck(id) {
      this.$router.push({path: '/vms/activityCheck', query: {id}});
    },
    clearFilter() {
      this.tableConfig = _.cloneDeep(this.initialFilterData);
    },
    goBack() {
      // this.$router.push({path: '/pages/activityManage'});
      this.$router.back();
    },
    handleSelectionChange(val) {
      console.log('<=====当前选中的数据有=====>', val);
      // todo: 后面应该是需要把数据的id提取出来进行删除
      this.multipleSelection = val;
    },
    async deleteActivity(id) {

      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let res = await axios.delete(vmsReqUrl+"activity/" + id)
          res = res.data
          if (res.code === 200) {
            await this.getData()
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {
        })
    },
    deleteActivities() {
      // todo: 批量删除数据后重新渲染表格
    },
    statusFormatter(row) {  //状态格式化
      switch (row.status) {
        case 1:
          return "未开始"
          break;
        case 2:
          return "进行中"
          break;
        case 3:
          return "已完成"
          break;
        default:
          return "未知"
          break;
      }
    },
    statusImageFormatter(row) {  //状态格式化
      switch (row.status) {
        case "progress":
          return "执行中"
          break;
        case "ok":
          return "已完成"
          break;
        default:
          return "未知"
          break;
      }
    },
    enabledFormatter(row) { //启用状态格式化
      switch (row.enabled) {
        case true:
          return "启用"
          break;
        case false:
          return "禁用"
          break;
        default:
          return "未知"
          break;
      }
    },
    forcedDisable(id, type, bool) {
      this.$confirm("是否确认强制禁用，强制禁用后该活动及活动相关的活动检查都将被删除！", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let res = await axios.post(vmsReqUrl+"activity/updateEnabled", {
            id,
            enabled: bool
          });
          res = res.data
          if (res.code === 200) {
            await this.getData()
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {
        })
    },
    enableActivity(id, type, bool) {
      this.$confirm("确认" + type + "吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let res = await axios.post(vmsReqUrl+"activity/updateEnabled", {
            id,
            enabled: bool
          });
          res = res.data
          if (res.code === 200) {
            await this.getData()
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {
        })
    },
    async exportReply(id) {
      let {data, fileName} = await this.$tool.exportFile({
        method: "post",
        url: vmsReqUrl+"/activity/activityStatistics/" + id,
      });
      console.log(data, fileName);
    },
    async exportImage(id) {
      let res = await axios.post(vmsReqUrl+"/activity/exportImages/" + id)
      res = res.data
      if (res.code === 200) {
        await this.getData()
        this.$message.success(res.message)
      } else {
        // this.$message.warning(res.message)
      }
    },
    // async exportRecord(id) {
    //   let {data, fileName} = await this.$tool.exportFile({
    //     method: "post",
    //     url: "/activity/exportList/" + id,
    //   });
    //   console.log(data, fileName);
    // },
    // 下载列表
    async exportRecord(id) {
      this.downloadDialog = true
      let res = await axios.post(vmsReqUrl+"/activity/exportList/" + id);
      this.downloadList = res.data.records
    },
    // 下载具体的文件
    downloadData(urls) {
      _.each(urls, (file) => {
        window.open(file)
      })
    },
  }
};
</script>
<style lang="sass" scoped>
.subActivityManage
  min-width: 1228px

  .subActivityManageBox
    padding: 20px

    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px

    .filter
      margin-top: 30px

    .label
      font-size: 14px
      color: #606266

    .table-container
      margin-top: 20px

    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/activity/subActivityManage.vue